export const msalConfig = {
	// auth: {
	// 	clientId: process.env.REACT_APP_CLIENT_ID!,
	// 	authority: process.env.REACT_APP_AUTHORITY!,
	// 	redirectUri: process.env.REACT_APP_REDIRECT_URI!,
	// },
	cache: {
		cacheLocation: "localStorage", // This configures where your cache will be stored
		storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
	},
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
	scopes: ["User.Read"],
	// scopes: [ "https://vault.azure.net/.default" ],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
// export const graphConfig = {
//     graphMeEndpoint: "Enter_the_Graph_Endpoint_Here/v1.0/me"
// };
